import axios from 'axios';
import { logout } from './auth';

export const API_BASE = process.env.REACT_APP_API_BASE;
// console.log("REACT_APP_API_BASE =", API_BASE);

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  timeout: 10000,
});

// Auto add token to headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Setup logout callback from React
let logoutCallback = null;
export const setLogoutCallback = (cb) => {
  logoutCallback = cb;
};

// Handle expired/unauthorized tokens
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only logout on 401 (token expired/invalid)
    // Let 403 (forbidden) pass through for permission-based error messages
    if (error.response?.status === 401) {
      logout(logoutCallback); // Clean logout with state update
    }
    return Promise.reject(error);
  }
);

export default api;
